module.exports = __webpack_public_path__ + "static/media/taco.ef1f29a7.svg";